import { toast } from 'react-toastify'

export function formatarTamanho(bytes?: number) {
  if (bytes == null || Number.isNaN(bytes)) return ''
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export function mensagemArquivoRejeitado(rejeitados: any[]) {
  const codigo = rejeitados?.[0]?.errors?.[0]?.code
  if (codigo === 'file-too-large') toast.error('O arquivo excede o limite de 5 MB.')
  else if (codigo === 'file-invalid-type') toast.error('Envie um arquivo PDF, JPG ou PNG.')
  else toast.error('Não foi possível adicionar o arquivo.')
}

export function mensagemErroEnvio(error: any) {
  const mensagem = error?.response?.data?.message
  toast.error(mensagem || 'Não foi possível enviar o arquivo.')
}

export const textoDropzone = 'PDF, JPG ou PNG, até 5 MB. Arraste os arquivos ou clique para inserir ...'
